import React from 'react';
import { Shield } from 'lucide-react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';

export const DriverInfoSection = ({ formData, handleChange }) => {
  return (
    <div className="border-l-4 border-purple-600 pl-6">
      <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Shield size={24} className="text-purple-700" />
        Informations Conducteur
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="firstName" className="text-base font-semibold">Prénom *</Label>
          <Input
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            placeholder="Prénom"
            required
            className="h-12"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="lastName" className="text-base font-semibold">Nom *</Label>
          <Input
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Nom"
            required
            className="h-12"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="birthDate" className="text-base font-semibold">Date de naissance *</Label>
          <Input
            id="birthDate"
            name="birthDate"
            type="date"
            value={formData.birthDate}
            onChange={handleChange}
            required
            className="h-12"
            max={new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split('T')[0]}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="licenseNumber" className="text-base font-semibold">Numéro de permis</Label>
          <Input
            id="licenseNumber"
            name="licenseNumber"
            value={formData.licenseNumber}
            onChange={handleChange}
            placeholder="123456789012"
            className="h-12"
          />
        </div>

        <div className="space-y-2 md:col-span-2">
          <Label htmlFor="address" className="text-base font-semibold">Adresse du domicile *</Label>
          <Input
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Numéro, rue, ville, code postal"
            required
            className="h-12"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="email" className="text-base font-semibold">Email *</Label>
          <Input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="votre@email.fr"
            required
            className="h-12"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="phone" className="text-base font-semibold">Téléphone *</Label>
          <Input
            id="phone"
            name="phone"
            type="tel"
            value={formData.phone}
            onChange={handleChange}
            placeholder="06 12 34 56 78"
            required
            className="h-12"
          />
        </div>
      </div>
    </div>
  );
};
